<div class="document-details-sub-table">
  <table mat-table [dataSource]="displayedData" multiTemplateDataRows class="width-100 mb-2">
    @for (column of columnsToDisplay; track column) {
      <ng-container matColumnDef="{{column}}">
      <th mat-header-cell *matHeaderCellDef [ngClass]="{
        'column-width-3': column === 'action',
        'column-width-2': column === 'status',
        'column-width-1': column === 'name',
        'column-width-0': column === 'icon'
        }"> <div class="cell">{{getColumnTitles(column)}}</div>
        </th>
        <td mat-cell *matCellDef="let element">
          <div class="cell">
            @if (column === 'name') {
              <div class="file-name">{{element?.metadata[column]}}</div>
              <div class="date-text">{{element?.properties?.lastModified | date:'dd/MM/yyyy h:mm:ss a'}}</div>
              @if (isInternalUser(user)) {
                @if (!(element?.metadata?.createduser && tagName === 'approvalnotice')) {
                  @if (element?.metadata[tagName] === 'Accepted') {
                    <div class="date-text">Accepted by {{element?.metadata?.statuschangeuser ?? 'system'}}</div>
                  }
                  @if (element?.metadata[tagName] === 'Rejected') {
                    <div class="date-text">Rejected by {{element?.metadata?.statuschangeuser ?? 'system'}}</div>
                  }
                }
                @if (element?.metadata?.createduser && tagName === 'approvalnotice') {
                  <div class="date-text">Sent by {{element?.metadata?.createduser}}</div>
                }
              }
            }
            @if (column === 'status') {
              <tag-box [state]="element?.metadata[tagName]"></tag-box>
            }
            @if (column === 'action') {
              <div fxLayout="row wrap"
                fxLayoutAlign="start center"
                fxLayout.lt-md="column"
                fxLayoutAlign.lt-md="center center"
                >
                <span class="mdi mdi-download cursor-pointer icon-margin" matTooltip="Download" (click)="onDownloadDoc(element)"></span>
                @if (isInternalUser(user)) {
                  <span class="mdi mdi-pencil cursor-pointer icon-margin" matTooltip="Edit" (click)="onEditDoc(element)"></span>
                }
                @if (isInternalUser(user)) {
                  <span class="mdi mdi-check cursor-pointer icon-margin" matTooltip="Accept" (click)="onApproveDoc(element)"></span>
                }
                @if (isInternalUser(user)) {
                  <span class="mdi mdi-close cursor-pointer icon-margin" matTooltip="Reject" (click)="onDeclineDoc(element)"></span>
                }
                @if (isInternalUser(user)) {
                  <span class="mdi mdi-arrow-u-left-top cursor-pointer icon-margin" matTooltip="Undo" (click)="onUndoDoc(element)"></span>
                }
                @if (isInternalUser(user)) {
                  <span class="mdi mdi-trash-can-outline cursor-pointer icon-margin" matTooltip="Delete" (click)="onDeleteDoc(element)"></span>
                }
              </div>
            }
          </div>
        </td>
      </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let element; columns: columnsToDisplay;" class="example-element-row">
    </tr>
  </table>
</div>
